export default "__VITE_ASSET__DFDzEb_M__"